import { useState } from "react";
import Calendar from "@/assets/calender.svg";
import ClockCircle from "../../assets/clock-circle.svg";
import Close from "../../assets/close.svg";
import InfoCircle from "../../assets/info-circle.svg";

export type ToastType = "default" | "success" | "warning" | "error" | "info";

export interface ToastProps extends React.DOMAttributes<HTMLDivElement> {
  toastType: ToastType;
  title: string | JSX.Element;
  subTitle: string;
  date: string;
  time: string;
  showIcon?: boolean;
  showClose: boolean;
  txnLink?: string;
}

export const Toast = ({
  toastType = "default",
  title,
  subTitle,
  date,
  time,
  showIcon = true,
  showClose = false,
  txnLink = "",
}: ToastProps) => {
  const [showToast, setShowToast] = useState<boolean>(true);

  const getToastTextClassName = () => {
    switch (toastType) {
      case "success":
      case "error":
      default:
      case "warning":
        return "text-white";
      case "info":
        return "text-black";
    }
  };

  const handleCloseClick = () => {
    setShowToast(false);
  };

  if (!showToast) {
    return <></>;
  }

  return (
    <div className="w-full relative flex flex-row items-start gap-2  p-4 rounded-lg shadow-e500">
      {showIcon && (
        <div>
          <InfoCircle className={`h-6 w-6 ${getToastTextClassName()}`} />
        </div>
      )}
      <div className="flex flex-col gap-2">
        <p className={`text-sm font-semibold ${getToastTextClassName()}`}>
          {title}
        </p>
        {subTitle.length > 0 && (
          <p className={`text-sm font-normal ${getToastTextClassName()}`}>
            {subTitle}
          </p>
        )}
        {txnLink.length > 0 && (
          <p className={`text-sm font-normal ${getToastTextClassName()}`}>
            <a
              href={txnLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`text-sm font-normal cursor-pointer underline ${getToastTextClassName()}`}
            >
              View Transaction
            </a>
          </p>
        )}
        <div
          className={`mt-2 flex flex-row items-center gap-3 ${getToastTextClassName()}`}
        >
          <div className="flex flex-row gap-1 items-center">
            <Calendar className="text-base-icon dark:text-dark-base-icon w-4 h-4" />
            <span className="text-[11px] font-normal leading-3">{date}</span>
          </div>
          <div className="flex flex-row gap-1 items-center">
            <ClockCircle className="text-base-icon dark:text-dark-base-icon w-4 h-4" />
            <span className="text-[11px] font-normal leading-3">{time}</span>
          </div>
        </div>
      </div>
      {showClose && (
        <button className="absolute top-1 right-1" onClick={handleCloseClick}>
          <Close className="text-base-icon dark:text-dark-base-icon w-6 h-6" />
        </button>
      )}
    </div>
  );
};

Toast.displayName = "Toast";
